module.exports = __webpack_public_path__ + "static/media/4S.d93c679d.svg";